import React from 'react';
import PropTypes from 'prop-types';
import PhotoReports from 'images/Reports@2x.jpg';
import ValuePropsModal from './ValuePropsModal';
import { FormattedMessage } from 'react-intl';

export default function ReportsValuePropsModal({ onRequestClose }) {
  const formattedTitle = (
    <FormattedMessage
      id="ValueProps.reports.title"
      defaultMessage="Photo Reports"
      description="Title to name Photo Reports"
    />
  );

  const formattedDescription = (
    <FormattedMessage
      id="ValueProps.reports.description"
      defaultMessage="Create clean, customized reports that you can share from anywhere."
      description="Description to explain what are Photo Reports"
    />
  );

  const formattedChecklistItems = [
    <FormattedMessage
      id="ValueProps.reports.valuePropA"
      defaultMessage="Choose your layout and drop in photos"
      description="Value prop of Reports feature"
    />,
    <FormattedMessage
      id="ValueProps.reports.valuePropB"
      defaultMessage="Customize with project information"
      description="Value prop of Reports feature"
    />,
    <FormattedMessage
      id="ValueProps.reports.valuePropC"
      defaultMessage="Save your report as a PDF"
      description="Value prop of Reports feature"
    />,
    <FormattedMessage
      id="ValueProps.reports.valuePropD"
      defaultMessage="Generate a shareable link in seconds"
      description="Value prop of Reports feature"
    />,
  ];

  return (
    <ValuePropsModal
      title={formattedTitle}
      description={formattedDescription}
      checklistItems={formattedChecklistItems}
      image={PhotoReports}
      isOpen
      onRequestClose={onRequestClose}
    />
  );
}

ReportsValuePropsModal.propTypes = {
  onRequestClose: PropTypes.func,
};
